import { define } from '../../define.js';
import { InputOtp } from './input-otp.js';
export * from './input-otp.js';
define('input-otp', InputOtp);
